import { ArrowLeftColor } from "@components";
import { IMemberTier } from "@interfaces";
import { selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

interface IProps {
    socials: JSX.Element[];
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentBadgesDetail = (props: IProps) => {
    //page props
    const { socials } = props;
    const { t } = useTranslation();
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);

    return (
        <>
            <RenderMeta title={t("meta.badgesdetail_page")} />
            <StyledBadgesDetail themeColor={themes?.themeColor!}>
                <div className="back-arrow">
                    <ArrowLeftColor color={themes?.themeColor} onClick={() => history.goBack()} />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                {/* <div className="img-banner">
                    <span>
                        <img src="../images/img-badges-detail.png" alt="" />
                    </span>
                </div> */}
                <div className="layout-content-dialog">
                    <div className="top-content">
                        <span>Collect Badges Dimoo</span>
                    </div>
                    <div className="main-content">
                        <div className="box-content">
                            <div className="title-content">
                                Your Progress <span>Completed : 3/7</span>
                            </div>
                            {/* <div className="img-badges-detail">
                                <img src="../images/img-badges-process-detail.png" alt="" />
                            </div> */}
                            <div className="layout-reward">
                                <ul>
                                    <li>
                                        <div className="box-reward">
                                            <div className="status-reward">
                                                <img src="../../images/ic-mark-reward.png" alt="" />
                                            </div>
                                            <img src="../../images/ic-user-reward.png" alt="" />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="box-reward">
                                            <div className="status-reward">
                                                <img src="../../images/ic-mark-reward.png" alt="" />
                                            </div>
                                            <img src="../../images/ic-user-reward.png" alt="" />
                                            <div className="pride-reward">100</div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="box-reward">
                                            <div className="status-reward">
                                                <img src="../../images/ic-lock-reward.png" alt="" />
                                            </div>
                                            <img src="../../images/ic-user-reward.png" alt="" />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="box-reward">
                                            <div className="status-reward">
                                                <img src="../../images/ic-lock-reward.png" alt="" />
                                            </div>
                                            <img src="../../images/ic-user-reward.png" alt="" />
                                            <div className="pride-reward">100</div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="box-reward">
                                            <div className="status-reward">
                                                <img src="../../images/ic-lock-reward.png" alt="" />
                                            </div>
                                            <img src="../../images/ic-user-reward.png" alt="" />
                                            <div className="pride-reward">500</div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="des-content-dialog">
                                <div className="title-des">
                                    Description
                                    <span className="time">2 weeks left</span>
                                </div>
                                <p>
                                    Share collection dimoo 7 times on social media 7 app login and
                                    visit our website 4 times from one of email. Then, you will a
                                    free shipping benefit for 6 months{" "}
                                    <span className="readmore">Read more</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </StyledBadgesDetail>
        </>
    );
};

const StyledBadgesDetail = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    background-color: #fff;
    background-position: right top;
    background-repeat: no-repeat;
    position: relative;
    background-image: url(../../images/img-detail-badges-reward-01.png);
    background-size: 100%;
    .btn-page {
        margin: 16px 0;
        position: fixed;
        bottom: 16px;
        left: 16px;
        width: calc(100% - 32px);
    }
    .layout-content-dialog {
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        background-color: #f3efeb;
        padding: 0 0 130px;
        overflow: hidden;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        .top-content {
            width: 100%;
            padding: 16px 16px;
            background-color: #f3efeb;
            span {
                background-image: url(../../images/trophy.png);
                font-size: 18px;
                line-height: 21px;
                font-weight: 600;
                background-position: left center;
                background-repeat: no-repeat;
                padding-left: 30px;
            }
        }
        .main-content {
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            overflow: hidden;
            background: linear-gradient(
                180deg,
                rgba(255, 201, 217, 1) 0%,
                rgba(255, 255, 255, 0) 50%
            );
            padding: 16px;
            .box-content {
                border-bottom: 1px solid #e1e1e1;
                margin: 0 0 16px;
                &:last-child {
                    border: none;
                }
                .layout-reward {
                    min-height: 60px;
                    border-radius: 52px;
                    background: linear-gradient(
                        158deg,
                        rgba(247, 145, 148, 1) 0%,
                        rgba(214, 134, 176, 1) 100%
                    );
                    margin-bottom: 12px;
                    padding-top: 20px;
                    margin-top: 50px;
                    ul {
                        display: grid;
                        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
                        list-style: none;
                        list-style-position: inside;
                        padding: 0;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                        li {
                            margin-top: -50px;
                            .box-reward {
                                position: relative;
                                text-align: center;
                                // background-image: url(../../images/bg-wood.png);
                                background-repeat: no-repeat;
                                background-size: contain;
                                background-position: center;
                                height: 55px;
                                .pride-reward {
                                    border-radius: 40px;
                                    height: 15px;
                                    width: 50px;
                                    background-color: rgba(255, 255, 255, 0.82);
                                    background-image: url(../../images/ic-coin-reward.png);
                                    background-repeat: no-repeat;
                                    background-position: left center;
                                    background-repeat: no-repeat;
                                    background-position: 4px center;
                                    padding-left: 12px;
                                    font-size: 10px;
                                    font-weight: 600;
                                    position: absolute;
                                    left: 50%;
                                    bottom: 0;
                                    transform: translateX(-50%);
                                }
                                .status-reward {
                                    position: absolute;
                                    top: -10px;
                                    right: 15px;
                                    img {
                                        width: 12px;
                                    }
                                }
                                img {
                                    width: 100%;
                                    max-width: 45px;
                                }
                            }
                            &:last-child {
                                .box-reward {
                                    height: 80px;
                                    .status-reward {
                                        position: absolute;
                                        top: -7px;
                                        right: 0;
                                        img {
                                            width: 16px;
                                        }
                                    }
                                    img {
                                        width: 100%;
                                        max-width: 70px;
                                    }
                                }
                            }
                        }
                    }
                }
                .des-content-dialog {
                    .title-des {
                        font-size: 14px;
                        font-weight: 600;
                        color: #000;
                        margin-bottom: 16px;
                        span.time {
                            float: right;
                            background-image: url(../../images/ic-time-dialog.svg);
                            background-position: left center;
                            background-repeat: no-repeat;
                            background-size: 16px;
                            padding-left: 20px;
                            color: #9b9b9b;
                        }
                    }
                }
                .img-badges-detail {
                    margin-bottom: 15px;
                    img {
                        width: 100%;
                    }
                }
                .herehow-title {
                    background-image: url(../../images/hand.svg);
                    font-size: 14px;
                    font-weight: 600;
                    background-position: left center;
                    background-repeat: no-repeat;
                    padding-left: 30px;
                    margin-bottom: 10px;
                }
                .title-content {
                    font-size: 14px;
                    color: #000;
                    font-weight: 600;
                    margin-bottom: 16px;
                    span {
                        float: right;
                        color: #3eba98;
                    }
                }
                p {
                    font-size: 14px;
                    line-height: 20px;
                    color: #525257;
                    margin-bottom: 16px;
                    span.readmore {
                        color: #b72a6c;
                        font-weight: 600;
                    }
                }
                ol {
                    padding: 0;
                    list-style-position: inside;
                    li {
                        font-size: 14px;
                        color: #525257;
                        span.hashtag {
                            background-color: #fffad1;
                            color: #ad9a09;
                        }
                    }
                }
            }
        }
    }
    .img-banner {
        width: 100%;
        position: relative;
        padding-top: 75%;
        z-index: 0;
        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        top: 15px;
        display: flex;
        align-items: center;
        z-index: 1;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
`;
const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    background: ${(p) => p.themeColor};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;
